import Entity from "../../../class/abstract/Entity";
import Store from "../../_account/Stores/Store";

class StoreSetting extends Entity {
    store_id = null;
    store = {};
    timeSlotBegin = 6;
    closingMinimalHour = 0;
    fiscalYearMonth = 1;
    keyPressSound = 0;
    saleSound = 0;
    assetValidity = 30;
    blurEnabled = 1;
    reinitCategoryAfterSale = 0;
    reinitSellerAfterSale = 0;
    reinitSellerAfterProduct = 0;
    reinitPricelistAfterSale = 0;
    reinitDefaultPricelist = 1;
    applyClientPricelistToExistingsContents = 1;
    reinitPricelistAfterProduct = 0;
    kartPrefix = "";
    sleepDelay = 0;
    paymentProofLabel = "Repas";
    saleBarcode = 0;
    kartBarcode = 0;
    assetBarcode = 0;
    receiptHeader = "{}";
    receiptFooter = "{}";
    autoBarcodeSellers = 0;
    barcodePrefixes = "{}";
    theme = "darkBlue";
    accumulateQuantities = 1;
    accountantEmail = "";
    sellerDetailsPrinting = 1;
    categoryDetailsPrinting = 1;
    productDetailsPrinting = 1;
    printPaymentsDetailUnit = 0;
    activeDiners = 0;
    forceIdentifiant = 0;
    forceDiners = 0;
    timezone = "Europe/Paris";
    displayNotification= 1;
    delayNotification= 6;
    automaticDatetimeControl= 1;
    allowedProductCreation= 0;
    allowedPriceUpdate= 0;
    automaticNotePrinting= 0;
    sellerInterupt= 0;
    sellerTimer= null;
    zerosixApiKey = null;
    yavinApiKey = null;
    otamiApiKey = null;
    otamiSynchronized = null;
    color = null;
    logo = null;
    iban = null;
    billGeneralConditions = null;
    url = "";
    urlSync = "";
    notifyCashIn = null;
    notifyCashOut = null;
    notifyDrawerEmptyCollection = null;
    notifyDrawerLowCollection = null;
    notifyDrawerHighCollection = null;
    notifyDrawerFullCollection = null;
    notifyDrawerEmptyDevice = null;
    notifyDrawerLowDevice = null;
    notifyDrawerHighDevice = null;
    notifyDrawerFullDevice = null;
    notifyDrawerIssue = null;
    notifyRebootDrawer = null;
    notifyReplaceCashCassette = null;
    notifyReplaceCoinCassette = null;
    drawerThreshold = null;
    notifyDrawerThreshold = null;
    notifyPwdTracker = null;
    sendDailyClosingToAccountant = null;
    sendMonthlyClosingToAccountant = null;
    sendYearlyClosingToAccountant = null;
    storeOpeningHours = "{}";
    storeClosingHours = "{}";
    highAffluenceThreshold = null;
    timeSlotPurchaseOrder = 30;
    requireDepositPurchaseOrder = "NONE";
    typeDepositPurchaseOrder = null;
    valueDepositPurchaseOrder = null;

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        if (datas === null)
            return;

        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                switch(key) {
                    case "store":
                        Reflect.set(this, key, new Store(datas[key]))
                        break
                    case "receiptHeader":
                    case "receiptFooter":
                        let val = datas[key]

                        if (val === "\"[]\"")
                            val = JSON.stringify([])

                        Reflect.set(this, key, val)
                        break
                    case "sellerInterupt":
                        Reflect.set(this, key, datas[key] === 1 ? 0 : 1);
                        break;
                    default:
                        Reflect.set(this, key, datas[key])
                        break
                }
            }
        }
    }
}

export default StoreSetting;
